export default __webpack_public_path__ + "static/blob13-550db0a5cb8b3501920d4c30f3090771.svg";